import React from 'react'
import clsx from 'clsx'
import styles from './styles.module.scss'

type Props = {
  children: React.ReactNode,
  className?: string,
  title?: string,
}

export default function SearchBlock({ children, title, className }: Props) {
  return (
    <div className={clsx(styles.searchBlock, className)}>
      {title ? (
        <div className={styles.title}>{title}</div>
      ) : null}
      {children}
    </div>
  )
}
